export function randa(array) {
    return array[Math.floor(Math.random() * array.length)];
}
